import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgClass } from "@angular/common";
import Delta from "quill-delta";
import { CdkTrapFocus } from "@angular/cdk/a11y";
import { TmRichTextAreaComponent } from "../../shared/ui/rich-text-area/rich-text-area.component";
import { IsEditable, LinkPreview, RichTextComment, Thread, ThreadAuthor } from "@teammood/timeline";

@Component({
    selector: "manager-comment-input",
    templateUrl: "./manager-comment-input.component.html",
    styleUrls: ["./manager-comment-input.component.scss"],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TmRichTextAreaComponent,
        TranslateModule,
        NgClass,
        CdkTrapFocus,
    ]
})
export class ManagerCommentInputComponent implements OnInit, OnChanges {

    @Input({required: true}) comment: RichTextComment;
    @Input() setFocus: boolean;
    @Input() updateMode: boolean = false;
    @Input() commentAuthors: ThreadAuthor[];
    @Input() editMode: boolean = false; //todo necessary?

    @ViewChild('newCommentInput') newCommentInput: ElementRef;

    @ViewChild('richTextAreaComponent') richTextAreaComponent: TmRichTextAreaComponent;

    @Output()
    onCommentAdded: EventEmitter<RichTextComment> = new EventEmitter();

    @Output()
    onCancelUpdates: EventEmitter<void> = new EventEmitter();

    protected hideTextareaPlaceholder: boolean;
    protected rtaContent: Delta;
    protected isFieldEmplty: boolean;

    constructor(
        private cdr: ChangeDetectorRef
    ){}

    ngOnInit() {
        // for whatever reason, we need to explicitly cast the message
        this.comment = new RichTextComment(this.comment.rawTextFormat, this.comment.htmlFormat, this.comment.objectModelFormat);
        this.rtaContent = this.comment.objectModelFormat;
        if (!this.comment.isEmpty()) {
            this.hideTextareaPlaceholder = true;
            this.cdr.detectChanges(); 
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.setFocus?.currentValue) {
            setTimeout(() => {
                const nativeElement = this.newCommentInput?.nativeElement as HTMLInputElement;
                if (nativeElement) {
                    nativeElement.focus();
                }
            }, 0);
        }
    }

    private hide() {
        this.hideTextareaPlaceholder = false;
        this.rtaContent = new Delta();
    }

    protected save() {
        this.comment.objectModelFormat = this.rtaContent;
        this.onCommentAdded.emit(this.comment);
        this.hide();
    }

    protected cancelUpdates(): void {
        this.onCancelUpdates.emit();
        this.hide();
    }

    protected emptyContent(): boolean {
        return RichTextComment.isEmptyDelta(this.rtaContent);
    }

    onContentChange(update: Delta){
        this.rtaContent = update;
        this.isFieldEmplty = RichTextComment.isEmptyDelta(this.rtaContent);
        this.cdr.detectChanges(); // Force change detection
    }

    showMentions() {
        this.richTextAreaComponent.showMentions();
    }
}


export class ManagerComment implements IsEditable {
    id?: string;
    message: RichTextComment;
    datetime: string;
    isEdited: boolean;
    moderationStatus?: string;
    linkPreviews?: LinkPreview[];
    isEditable: boolean;

    constructor() {
        this.message = RichTextComment.createNew();
        this.id =  (Math.random() + 1).toString(36).substring(7);
    }
}